import React, { useRef, useEffect } from 'react';
import './BackToSchool.scss';
import { setScrollNaming } from '../../Services/ScrollURL';


const BackToSchool = (props) => {

    const { setTransform } = props;
    const section = useRef(null);

    // useEffect(() => {
    //     setScrollNaming(section.current);
    // }, [])

    return (
        <section className="section section-backtoschool" ref={section} >
            <div className="bg"></div>
            <div className="padding">
                <div className="container">
                    <div className="promo"></div>
                </div>
                <div onClick={() => setTransform(1)} className="nav-button">
                    <div className="button-text" >
                        למתכוני כריכים מגוונים
                    </div>
                    <div className="arrow"></div>
                </div>
            </div>
        </section>
    )
}

export default BackToSchool



// WEBPACK FOOTER //
// ./src/Components/Screens/0_BackToSchool/BackToSchool.jsx